import { render, staticRenderFns } from "./form.vue?vue&type=template&id=526d84fa&scoped=true&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"
import style0 from "./form.vue?vue&type=style&index=0&id=526d84fa&lang=scss&scoped=true&"
import style1 from "./form.vue?vue&type=style&index=1&id=526d84fa&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526d84fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('526d84fa')) {
      api.createRecord('526d84fa', component.options)
    } else {
      api.reload('526d84fa', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=526d84fa&scoped=true&", function () {
      api.rerender('526d84fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/medical-analyses/form.vue"
export default component.exports